import { useQuery } from "@tanstack/react-query";
import { generatePath, Navigate } from "react-router-dom";

import { ErrorState } from "@/app/components/legacy-components";
import { ROUTES } from "@/app/router";
import { formQueriesStore } from "@/features/forms/api";
import { useIntakeFormContext } from "@/features/intake-form/context";
import { INTAKE_FORM_ROUTE } from "@/features/intake-form/router";
import { LogoLoader } from "@/shared/components";
import { REFILL_TYPE } from "@/shared/models";
import { JourneyRestricted } from "./journey-restricted";

export const ChooseJourney = () => {
  const { subscription } = useIntakeFormContext();

  const {
    data: availableRefillTypes,
    isPending,
    isError,
  } = useQuery(formQueriesStore.refill(subscription.id)._ctx.types);

  if (isError) {
    return <ErrorState className="-translate-y-10 border-none" />;
  }

  if (isPending) {
    return <LogoLoader withOverlay />;
  }

  if (!availableRefillTypes.length) {
    return <Navigate to={ROUTES.BASE} />;
  }

  const onlySync = availableRefillTypes.every(
    (type) => type === REFILL_TYPE.SYNC,
  );

  if (!onlySync) {
    return (
      <Navigate
        to={generatePath(INTAKE_FORM_ROUTE.ASSESSMENT_FORM, {
          userPreference: REFILL_TYPE.ASYNC,
          productId: null,
        })}
        replace
      />
    );
  }

  return <JourneyRestricted open={onlySync} />;
};
